// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface IUndeliverableMailMetricsResponseDto
 */
export interface IUndeliverableMailMetricsResponseDto {
    /**
     * 
     * @type {number}
     * @memberof IUndeliverableMailMetricsResponseDto
     */
    flagged_employees_count?: number;
}

/**
 * Check if a given object implements the IUndeliverableMailMetricsResponseDto interface.
 */
export function instanceOfIUndeliverableMailMetricsResponseDto(value: object): value is IUndeliverableMailMetricsResponseDto {
    return true;
}

export function IUndeliverableMailMetricsResponseDtoFromJSON(json: any): IUndeliverableMailMetricsResponseDto {
    return IUndeliverableMailMetricsResponseDtoFromJSONTyped(json, false);
}

export function IUndeliverableMailMetricsResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IUndeliverableMailMetricsResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'flagged_employees_count': json['flagged_employees_count'] == null ? undefined : json['flagged_employees_count'],
    };
}

export function IUndeliverableMailMetricsResponseDtoToJSON(json: any): IUndeliverableMailMetricsResponseDto {
    return IUndeliverableMailMetricsResponseDtoToJSONTyped(json, false);
}

export function IUndeliverableMailMetricsResponseDtoToJSONTyped(value?: IUndeliverableMailMetricsResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'flagged_employees_count': value['flagged_employees_count'],
    };
}

